import { Avatar, styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const ViewerRolesRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const ViewerRolesAvatar = styled(Avatar)({
  width: '1.5rem',
  height: '1.5rem',
  fontSize: '0.6rem',
  marginRight: '0.2rem',
  backgroundColor: grey[700],
});
